import { FormValues, RequestFieldsValues } from "../types"

export const formatRequestData = (inputs: RequestFieldsValues) => {
  return {
    request_data: {
      inputs,
    },
    request_meta: {
      version_id: "eb3b7f9a-c39a-4178-a85d-176b6d7dfe09",
      call_purpose: "Spark - API Tester",
      source_system: "SPARK",
      correlation_id: "",
      requested_output: null,
      service_category: "",
    },
  }
}

export const prepareEditableJsonData = () => {
  return {
    request_data: {
      inputs: {
        Active_Ppts: 100,
        Deposit_Annual: 125000,
        Eligible_EEs: 100,
        Fee_Asset: 0.0005,
        Fee_Deposit: 0.002,
        Fund_Type: "Mid Market",
        Inactive_Ppts: 500,
        Product: "Product Basic",
        RolloverContributions: 100000,
        ServiceModel: "Service Basic",
        SV2_Fund: "Cash",
        TDF_Fund_Name: "TDF Fund D",
        TotalAssets: 6500000,
      },
    },
    request_meta: {
      version_id: "eb3b7f9a-c39a-4178-a85d-176b6d7dfe09",
      call_purpose: "Spark - API Tester",
      source_system: "SPARK",
      correlation_id: "",
      requested_output: null,
      service_category: "",
    },
  }
}

export const formatFormValues = (values: FormValues) => {
  return values as unknown as RequestFieldsValues
}

export const formatToNumber = (value: string): number => {
  var newValue = value.replace(/[%$,]/g, "").trim()
  return +newValue
}
